import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,{style:({background: _vm.$vuetify.theme.themes[_vm.theme].background})},[_c(VMain,[_c('router-view',{staticClass:"pa-2",on:{"authenticated":_vm.setAuthenticated}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }